// Shared `WineReceiving.*` and `WineReceivingV2.*` i18n keys.
// Consumers:
//   - 20260527_WineReceiving.vue (legacy date-prefixed backup, not routed)
//   - WineReceivingV2.vue (live — mounted as a drawer by BottleListing.vue)
// Note: WineReceiving.* is intentionally kept distinct from the shared `wine.*`
// namespace in ./wine.ts because the receiving form fields are tuned to the
// bulk-receiving flow (multi-row, no per-row beverage type), and the canonical
// `wine.*` keys cover the catalog/listing/detail form flows.

export const wineReceivingDict: Record<string, [en: string, th: string]> = {
  // ── WineReceiving (V1, also still used by 20260527_WineReceiving.vue) ──
  "WineReceiving.addRow": ["Add Row", "เพิ่มแถว"],
  "WineReceiving.submitAll": ["Submit All", "บันทึกทั้งหมด"],
  "WineReceiving.receiptRef": ["Receipt Ref", "เลขที่ใบรับ"],
  "WineReceiving.receiptRefHint": ["Auto-generated, or enter your invoice/PO reference", "สร้างอัตโนมัติ หรือใส่เลขที่ใบแจ้งหนี้/ใบสั่งซื้อ"],
  "WineReceiving.wine": ["Wine", "ไวน์"],
  "WineReceiving.purchaseDate": ["Purchase Date", "วันที่ซื้อ"],
  "WineReceiving.costPerUnit": ["Purchase Price", "ราคาซื้อ"],
  "WineReceiving.location": ["Location", "ตำแหน่ง"],
  "WineReceiving.supplier": ["Supplier", "ซัพพลายเออร์"],
  "WineReceiving.note": ["Note", "หมายเหตุ"],
  "WineReceiving.confirmTitle": ["Submit Bulk Receiving?", "ยืนยันการรับเข้าหลายรายการ?"],
  "WineReceiving.confirmText": ["This will create {count} receipt lines from this session.", "จะสร้าง {count} รายการจากรอบรับเข้านี้"],
  "WineReceiving.success": ["Successfully created {count} receipt lines", "สร้าง {count} รายการสำเร็จ"],
  "WineReceiving.partialFail": ["{success} succeeded, {fail} failed", "{success} สำเร็จ, {fail} ล้มเหลว"],
  "WineReceiving.emptyRow": ["Add at least one wine to receive", "เพิ่มอย่างน้อย 1 รายการเพื่อรับเข้า"],
  "WineReceiving.sellingPrice": ["Selling Price", "ราคาขาย"],
  "WineReceiving.marketPrice": ["Market Price", "ราคาตลาด"],

  // ── WineReceivingV2 (live drawer component) ─────────────
  "WineReceivingV2.subtitle": [
    "รับสินค้าเข้าคลัง — สร้างใบรับและขวดอัตโนมัติ",
    "รับสินค้าเข้าคลัง — สร้างใบรับและขวดอัตโนมัติ",
  ],
  "WineReceivingV2.receivingItems": ["Receiving Items", "รายการรับเข้า"],
  "WineReceivingV2.rows": ["rows", "แถว"],
};
